(function (root, factory) {
  'use strict';
  var label = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = label;
  else if (root) root.WTXFirstOrderLabel = label;
}(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';

  var species = [
    ['chicken', 'Chicken', 'chicken'], ['beef', 'Beef', 'beef|bovine'],
    ['turkey', 'Turkey', 'turkey'], ['duck', 'Duck', 'duck'], ['rabbit', 'Rabbit', 'rabbit'],
    ['pork', 'Pork', 'pork|porcine'], ['lamb', 'Lamb', 'lamb|mutton|ovine'],
    ['venison', 'Venison', 'venison|deer'], ['bison', 'Bison', 'bison|buffalo'],
    ['goat', 'Goat', 'goat'], ['kangaroo', 'Kangaroo', 'kangaroo'],
    ['quail', 'Quail', 'quail'], ['pheasant', 'Pheasant', 'pheasant'],
    ['ostrich', 'Ostrich', 'ostrich'], ['alligator', 'Alligator', 'alligator'],
    ['salmon', 'Salmon', 'salmon'], ['whitefish', 'Whitefish', 'whitefish|white fish'],
    ['trout', 'Trout', 'trout'], ['cod', 'Cod', 'cod'], ['herring', 'Herring', 'herring'],
    ['sardine', 'Sardine', 'sardines?'], ['anchovy', 'Anchovy', 'anchov(?:y|ies)'],
    ['menhaden', 'Menhaden', 'menhaden'], ['mackerel', 'Mackerel', 'mackerel'],
    ['tuna', 'Tuna', 'tuna'], ['pollock', 'Pollock', 'pollock'], ['hake', 'Hake', 'hake'],
    ['fish', 'Fish (type unspecified)', 'fish'], ['egg', 'Egg', 'eggs?'],
    ['dairy', 'Dairy', 'milk|cheese|whey|casein'],
    ['insect', 'Insect', 'black soldier fly|crickets?|insect'],
    ['poultry', 'Poultry (type unspecified)', 'poultry'],
    ['animal', 'Animal source unspecified', 'animal|meat']
  ];
  var scriptLoads = new Map();
  var defaultReader = null;
  var MAX_BYTES = 12 * 1024 * 1024;

  function failure(code) {
    var error = new Error(code);
    error.code = code;
    return error;
  }

  function analyze(value, options) {
    options = options || {};
    var text = typeof value === 'string' ? value.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g, '').trim() : '';
    var output = { text: text, ingredientsText: '', animalIngredients: [], primaryCandidates: [], needsConfirmation: true, error: null };
    if (text.length > 12000) return Object.assign(output, { error: 'text_too_long' });
    if (text.length < 12 || (text.match(/[a-z]{2,}/gi) || []).length < 3) return Object.assign(output, { error: 'unreadable' });
    var heading = /\bingredients?\s*[:\-]?/i.exec(text);
    if (!heading && !options.confirmedIngredientText) return Object.assign(output, { error: 'ingredients_not_found' });
    var ingredients = (heading ? text.slice(heading.index + heading[0].length) : text)
      .split(/\b(?:guaranteed analysis|calorie content|feeding (?:guidelines|directions|instructions)|directions for use|manufactured (?:by|for)|distributed by|nutritional adequacy|AAFCO)\b/i)[0]
      .replace(/\s+/g, ' ').trim();
    output.ingredientsText = ingredients;
    var found = [];
    species.forEach(function (item) {
      var pattern = new RegExp('\\b(?:' + item[2] + ')\\b', 'gi');
      var match;
      while ((match = pattern.exec(ingredients))) {
        var start = ingredients.lastIndexOf(',', match.index) + 1;
        var end = ingredients.indexOf(',', match.index);
        var ingredient = ingredients.slice(start, end < 0 ? ingredients.length : end).trim();
        var before = ingredients.slice(start, match.index);
        var after = ingredients.slice(match.index + match[0].length, end < 0 ? ingredients.length : end);
        if (/\b(?:no|without|free (?:of|from))\s*$/i.test(before) || /^[\s-]*free\b/i.test(after)) continue;
        if (item[0] === 'fish' && /white\s*$/i.test(before)) continue;
        if (item[0] === 'animal' && /(?:chicken|beef|turkey|duck|rabbit|pork|lamb|venison|bison|goat|fish)\s*$/i.test(before)) continue;
        var role = /^[\s-]*(?:fat|oil|tallow)\b/i.test(after) ? 'fat_or_oil' :
          /^[\s-]*(?:flavou?r|digest)\b/i.test(after) ? 'flavor' :
          ['animal', 'poultry'].includes(item[0]) ? 'unspecified' : 'named_ingredient';
        found.push({ id: item[0], label: item[1], ingredient: ingredient, role: role, position: match.index });
      }
    });
    found.sort(function (a, b) { return a.position - b.position; });
    output.animalIngredients = found.filter(function (item, index) {
      return found.findIndex(function (other) { return other.id === item.id && other.role === item.role; }) === index;
    });
    output.primaryCandidates = output.animalIngredients.filter(function (item) {
      return item.role === 'named_ingredient' || item.role === 'unspecified';
    }).filter(function (item, index, all) { return all.findIndex(function (other) { return other.id === item.id; }) === index; });
    if (!ingredients || !output.animalIngredients.length) output.error = 'no_named_animal_ingredient';
    return output;
  }

  function confirm(input) {
    if (!input || input.confirmed !== true) return { error: 'confirmation_required' };
    var parsed = analyze(input.text, { confirmedIngredientText: true });
    if (parsed.error) return { error: parsed.error };
    var choice = input.primaryProtein;
    var ids = parsed.primaryCandidates.map(function (item) { return item.id; });
    if (choice === 'both' ? !ids.includes('beef') || !ids.includes('chicken') : !ids.includes(choice)) return { error: 'choose_visible_ingredient' };
    return {
      error: null,
      protein: ['beef', 'chicken', 'both'].includes(choice) ? choice : 'other',
      primaryProtein: choice,
      labelConfirmed: 'yes',
      ingredientsText: parsed.ingredientsText,
      animalIngredients: parsed.animalIngredients,
      source: 'customer-confirmed-photo-text'
    };
  }

  function checkFile(file) {
    if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) throw failure('unsupported_format');
    if (!Number.isFinite(file.size) || file.size <= 0) throw failure('empty_file');
    if (file.size > MAX_BYTES) throw failure('file_too_large');
  }

  function loadScript(url) {
    if (!root || !root.document) return Promise.reject(failure('unsupported_browser'));
    if (scriptLoads.has(url)) return scriptLoads.get(url);
    var promise = new Promise(function (resolve, reject) {
      var script = root.document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = function () { scriptLoads.delete(url); reject(failure('runtime_unavailable')); };
      root.document.head.appendChild(script);
    });
    scriptLoads.set(url, promise);
    return promise;
  }

  function assetURL(value) {
    if (typeof value !== 'string' || !value) throw failure('runtime_unavailable');
    var url = new URL(value, root && root.location ? root.location.href : 'https://invalid.local/');
    if (!['https:', 'http:'].includes(url.protocol)) throw failure('runtime_unavailable');
    return url.href;
  }

  async function runtime(config) {
    if (!root || !root.Worker || !root.WebAssembly || !config) throw failure('unsupported_browser');
    var scriptUrl = assetURL(config.scriptUrl);
    var workerUrl = assetURL(config.workerUrl);
    var corePath = assetURL(config.corePath);
    var langPath = assetURL(config.langPath);
    await loadScript(scriptUrl);
    if (typeof root.Tesseract?.createWorker !== 'function') throw failure('runtime_unavailable');
    return {
      createWorker: function (onProgress) {
        return root.Tesseract.createWorker('eng', 1, {
          workerPath: workerUrl,
          corePath: corePath,
          langPath: langPath,
          cacheMethod: 'none',
          logger: onProgress,
          errorHandler: function () {}
        });
      }
    };
  }

  async function prepareImage(file, rotation) {
    if (!root || !root.document) throw failure('unsupported_browser');
    var source;
    var objectUrl;
    try {
      if (typeof root.createImageBitmap === 'function') source = await root.createImageBitmap(file);
      else {
        objectUrl = root.URL.createObjectURL(file);
        source = await new Promise(function (resolve, reject) {
          var image = new root.Image();
          image.onload = function () { resolve(image); };
          image.onerror = function () { reject(failure('unreadable_image')); };
          image.src = objectUrl;
        });
      }
      var width = source.width || source.naturalWidth;
      var height = source.height || source.naturalHeight;
      if (!width || !height || width * height > 60000000) throw failure('image_too_large');
      if (Math.min(width, height) < 120) throw failure('image_too_small');
      var scale = Math.min(1, 2400 / Math.max(width, height), Math.sqrt(4000000 / (width * height)));
      var w = Math.round(width * scale);
      var h = Math.round(height * scale);
      var canvas = root.document.createElement('canvas');
      canvas.width = rotation % 180 ? h : w;
      canvas.height = rotation % 180 ? w : h;
      var context = canvas.getContext('2d', { alpha: false });
      if (!context) throw failure('unsupported_browser');
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.translate(canvas.width / 2, canvas.height / 2);
      context.rotate(rotation * Math.PI / 180);
      context.drawImage(source, -w / 2, -h / 2, w, h);
      return canvas;
    } catch (error) {
      throw error.code ? error : failure('unreadable_image');
    } finally {
      if (source && typeof source.close === 'function') source.close();
      if (objectUrl) root.URL.revokeObjectURL(objectUrl);
    }
  }

  function createReader(options) {
    options = options || {};
    var busy = false;
    return {
      recognize: async function (file, settings) {
        settings = settings || {};
        if (busy) throw failure('reader_busy');
        checkFile(file);
        var rotation = settings.rotation || 0;
        if (![0, 90, 180, 270].includes(rotation)) throw failure('invalid_rotation');
        if (settings.signal && settings.signal.aborted) throw failure('cancelled');
        busy = true;
        var worker = null;
        var expired = false;
        var timer;
        var abort;
        var cleanup = async function () {
          if (worker) {
            var current = worker;
            worker = null;
            try { await current.terminate(); } catch (_) {}
          }
        };
        var progress = function (event) {
          if (!expired && typeof settings.onProgress === 'function') {
            settings.onProgress({ status: event.status || 'reading', progress: Math.max(0, Math.min(1, Number(event.progress) || 0)) });
          }
        };
        try {
          var work = (async function () {
            progress({ status: 'preparing image', progress: 0 });
            var image = await (options.prepareImage || prepareImage)(file, rotation);
            if (expired) throw failure('cancelled');
            var loaded = await (options.loadRuntime ? options.loadRuntime() : runtime(options.runtime));
            if (expired) throw failure('cancelled');
            worker = await loaded.createWorker(progress);
            if (expired) { await cleanup(); throw failure('cancelled'); }
            await worker.setParameters({ tessedit_pageseg_mode: '6', preserve_interword_spaces: '1' });
            var recognized = await worker.recognize(image, { rotateAuto: true }, { text: true });
            if (expired) throw failure('cancelled');
            var data = recognized && recognized.data || {};
            var parsed = analyze(data.text);
            var confidence = Number.isFinite(data.confidence) ? data.confidence : 0;
            return Object.assign(parsed, {
              confidence: confidence,
              lowConfidence: confidence < 60,
              error: confidence < 60 ? 'unreadable' : parsed.error,
              processing: 'on-device-ocr',
              engine: 'Tesseract 6.0.1',
              rotation: rotation
            });
          }());
          var deadline = new Promise(function (_, reject) {
            abort = function () { expired = true; void cleanup(); reject(failure('cancelled')); };
            if (settings.signal) settings.signal.addEventListener('abort', abort, { once: true });
            timer = setTimeout(function () { expired = true; void cleanup(); reject(failure('recognition_timeout')); }, 60000);
          });
          return await Promise.race([work, deadline]);
        } catch (error) {
          throw error.code ? error : failure('recognition_failed');
        } finally {
          clearTimeout(timer);
          if (settings.signal && abort) settings.signal.removeEventListener('abort', abort);
          await cleanup();
          busy = false;
        }
      }
    };
  }

  function configure(config) { defaultReader = createReader({ runtime: config }); }
  function recognize(file, options) {
    if (!defaultReader) return Promise.reject(failure('runtime_unavailable'));
    return defaultReader.recognize(file, options);
  }

  return { configure: configure, recognize: recognize, createReader: createReader, analyze: analyze, confirm: confirm, maxBytes: MAX_BYTES };
}));
